import React from 'react';
import { Alert } from 'react-bootstrap';

const PageNotFound = () => {
  return (
    <div>
      <Alert variant="danger">La página no existe.</Alert>
    </div>
  );
};

export default PageNotFound;
